import React, { PureComponent, PropTypes } from 'react';
import _ from 'underscore';
import { Modal, Button, Table } from 'react-fast-ui';
import { NOTIFICATION_CONTEXT_TYPES } from '../../NotificationSystemProvider';
import EmptyState from '../../common/components/EmptyState';
import moment from 'moment';

export const SCOPES = {
  division: 'division',
  pool: 'pool',
  event: 'event',
  tourney: 'tourney',
  team: 'team',
  user: 'user',
  account: 'account',
  global: 'global'
};

class NotificationTable extends PureComponent {
  static propTypes = {
    notifications: PropTypes.arrayOf(PropTypes.object).isRequired
  };

  render() {
    const { notifications } = this.props;

    return (
      <Table>
        <Table.thead>
          <Table.th>Sent</Table.th>
          <Table.th>Message</Table.th>
        </Table.thead>
        <Table.tbody>
          {
            _.map(notifications,
              ({ id, message, sendAt }) => (
                <Table.tr key={id}>
                  <Table.td>
                    {moment(sendAt).fromNow()}
                  </Table.td>
                  <Table.td>
                    {message}
                  </Table.td>
                </Table.tr>
              ))
          }
        </Table.tbody>
      </Table>
    );
  }
}

class NotificationList extends PureComponent {
  static contextTypes = {
    dao: PropTypes.object.isRequired,
    ...NOTIFICATION_CONTEXT_TYPES
  };

  static propTypes = {
    viewing: PropTypes.shape({
      scope: PropTypes.oneOf(_.values(SCOPES)).isRequired,
      object: PropTypes.shape({ id: PropTypes.string.isRequired })
    })
  };

  state = {
    promise: null,
    notifications: null
  };

  componentDidMount() {
    this.loadNotifications(this.props.viewing);
  }

  componentWillReceiveProps({ viewing }) {
    if (viewing !== this.props.viewing) {
      this.loadNotifications(viewing);
    }
  }

  loadNotifications = ({ scope, object }) => {
    const { dao, onError } = this.context;
    const { promise } = this.state;

    if (!!promise) {
      promise.cancel();
    }

    const isString = typeof scope === 'string';
    const shouldFetch = isString && SCOPES[ scope ] && ((object && object.id) || scope === SCOPES.global);
    const loading = (shouldFetch) ?
      dao.notifications.getAll({
        scope,
        [ `${scope}Id` ]: object && object.id ? object.id : null
      }) :
      Promise.resolve(null);

    this.setState({
      promise: loading
        .then(
          notifications => this.setState({ notifications })
        )
        .catch(onError)
        .finally(
          () => this.setState({ promise: null })
        )
    });
  };

  render() {
    const { promise, notifications } = this.state;

    if (notifications === null) {
      if (!!promise) {
        return EmptyState.LOADING;
      } else {
        return <EmptyState iconProps={{ name: 'exclamation-triangle' }}>Failed to load notifications</EmptyState>;
      }
    }

    if (notifications.length === 0) {
      return <EmptyState iconProps={{ name: 'folder-o' }}>No notifications!</EmptyState>;
    }

    return (
      <NotificationTable notifications={notifications}/>
    );
  }
}

function getTitle({ scope, object }) {
  switch (scope) {
    case SCOPES.team:
    case SCOPES.division:
    case SCOPES.pool:
    case SCOPES.tourney:
      return `Notifications for ${scope} "${object.name}"`;
    default:
      return 'Sent Notifications';
  }
}

export default class ViewNotificationsModal extends PureComponent {
  render() {
    const { onClose, viewing, ...rest } = this.props;

    return (
      <Modal {...rest} onClose={onClose}>
        <Modal.Title onClose={onClose}>{viewing === null ? 'Sent Notifications' : getTitle(viewing)}</Modal.Title>
        <Modal.Body>
          {viewing && <NotificationList viewing={viewing}/>}
        </Modal.Body>
        <Modal.Footer>
          <Button text="Done" onClick={onClose}/>
        </Modal.Footer>
      </Modal>
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/components/modals/ViewNotificationsModal.jsx